
import React, { useState } from 'react'
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/scss/modal-video.scss';


const VideoModal = ({ externalUrl }) => {

  const [isOpen, setOpen] = useState(false)

  return (
    <React.Fragment>
      <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7VEo84LQpZU" onClose={() => setOpen(false)} />

      {externalUrl ? (
        <a className="video-btn" href={externalUrl} target="_blank" rel="noopener noreferrer">
          <i className="fi flaticon-play"></i>
        </a>
      ) : (
        <div className="video-btn" onClick={() => setOpen(true)}>
          <i className="fi flaticon-play"></i>
        </div>
      )}
     

    </React.Fragment>
  )
}

export default VideoModal;